import React from 'react'
import { Link } from "react-router-dom";
import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function About() {
  const page = "aboutus";
  useEffect(() => {
    // ensure Swiper script is loaded (from CDN in index.html <head>)
    if (!window.Swiper) return;
    const swiper = new window.Swiper('.materials-carousel', {
      speed: 500,
      spaceBetween: 28,
      slidesPerView: 3,
      slidesPerGroup: 1,
      grabCursor: true,
      keyboard: { enabled: true },
      navigation: {
        nextEl: '.materials-carousel .swiper-button-next',
        prevEl: '.materials-carousel .swiper-button-prev',
      },
      pagination: {
        el: '.materials-carousel .swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0:    { slidesPerView: 1 },
        640:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });

    return () => swiper?.destroy(true, true);
  }, []);  
  return (
    <div>
      {/* <Header /> */}

      <section className={`hero ${page}`}>
        <h1>About Us</h1>
      </section>

      {/* About DMC section */}
      <section className="about-section">
        {/* <div className="fullscreen-kicker">
          <h1>About US</h1>
        </div> */}
        <div className="container">
          <h2>Introduction</h2>
          <p>
            Founded in 2011, Drilling Materials Factory Company has become a leader in the drilling materials industry. We deliver high-quality, innovative solutions tailored to the oil and gas sector, water wells, and other industries—always with a focus on performance, sustainability, and customer satisfaction.
          </p>
          {/*p>
            Our mission is to set the gold standard in drilling materials globally, driven by a focus on both performance and sustainability. We aim to achieve this by constantly advancing our research and development efforts to create innovative solutions that improve drilling efficiency and safety while minimizing environmental impact.
          </p>
          <p>
            We understand that sustainable practices are not just a responsibility but also a key to long-term success. By reducing waste, optimizing resource use, and developing environmentally friendly products, we strive to support our clients in meeting their operational goals and regulatory requirements while contributing to a healthier planet.
          </p*/}
        </div>
        <div className="container">
          <h2>Mission</h2>
          <p>
            The Company is committed to delivering superior products and solutions in the drilling, construction, 
            consumer, and industrial sectors. By leveraging its technical expertise, investing in innovation, 
            empowering its people, and embracing sustainability, the Company creates long-term value for its customers, 
            partners, and shareholders.
          </p>
        </div>
        <div className="container">
          <h2>Vision</h2>
          <p>
            To be an innovative industrial company, trusted regionally and recognized globally, shaping the future of 
            drilling materials and minerals across diverse markets, with sustainability, performance, and purpose as core 
            pillars.
          </p>
        </div>
      </section>

      <section className="materials-section" id="materials">
        <div className="container">
          <div className="materials-heading">
            <div className="materials-kicker" aria-hidden="true">Core values</div>
          </div>

          {/* CAROUSEL */}
          <div className="materials-carousel swiper">
            <div className="swiper-wrapper">

              {/* Slide (repeat for each product) */}
              <div className="swiper-slide">
                <article className="material-card">
                  <div className="thumb">
                    <img src="assets/images/icons/innovation.png" alt="INNOVATION" />
                  </div>
                  <h3 className="title">INNOVATION</h3>
                  <p className="description">
                    We lead with cutting-edge technological advancements, consistently developing new products and refining processes to stay ahead of industry challenges.
                  </p>
                  <a className="btn-readMore" href="/about/innovation">Read More
                    <svg className="btn-arrow" viewBox="0 0 50 20" fill="none" aria-hidden="true">
                      <path d="M0 12h50M43 5l7 7-7 7"
                        stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>            
                </article>
              </div>

              <div className="swiper-slide">
                <article className="material-card">
                  <div className="thumb">
                    <img src="assets/images/icons/quality.png" alt="QUALITY" />
                  </div>
                  <h3 className="title">QUALITY</h3>
                  <p className="description">
                    Our dedication to quality is second to none. We uphold strict standards to ensure that every product meets or exceeds expectations.
                  </p>
                  <a className="btn-readMore" href="/about/quality">Read More
                    <svg className="btn-arrow" viewBox="0 0 50 20" fill="none" aria-hidden="true">
                      <path d="M0 12h50M43 5l7 7-7 7"
                        stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </article>
              </div>

              <div className="swiper-slide">
                <article className="material-card">
                  <div className="thumb">
                    <img src="assets/images/icons/sustain.png" alt="SUSTAINABILITY" />
                  </div>
                  <h3 className="title">SUSTAINABILITY</h3>
                  <p className="description">
                    Environmental responsibility is integral to our business strategy. We are committed to sustainable productivity and are actively working towards a greener future.
                  </p>
                  <a className="btn-readMore" href="/about/sustainability">Read More
                    <svg className="btn-arrow" viewBox="0 0 50 20" fill="none" aria-hidden="true">
                      <path d="M0 12h50M43 5l7 7-7 7"
                        stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>            
                </article>
              </div>

              <div className="swiper-slide">
                <article className="material-card">
                  <div className="thumb">
                    <img src="assets/images/icons/custom-center.png" alt="CUSTOM-CENTRIC APPROACH" />
                  </div>
                  <h3 className="title">CUSTOM-CENTRIC APPROACH</h3>
                  <p className="description">
                    Our clients are central to everything we do. We anticipate their needs and provide tailored solutions that drive their success.
                  </p>
                  {/* <a className="btn-readMore" href="/about/customer-center">Read More */}
                  <Link className="btn-readMore" to="/about/customer-center">Read More
                    <svg className="btn-arrow" viewBox="0 0 50 20" fill="none" aria-hidden="true">
                      <path d="M0 12h50M43 5l7 7-7 7"
                        stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </Link>
                  {/* </a> */}
                </article>
              </div>
            </div>

            {/* Controls */}
            <div className="swiper-button-prev" aria-label="Previous"></div>
            <div className="swiper-button-next" aria-label="Next"></div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>


      {/* <Footer /> */}
    </div>
  )
}

export default About